import React from "react";
import PropTypes from "prop-types";
import { safetyProductsConstant } from "./safetyProductsConstant";

import ProductDisplayWithDescription from "../shared-components/ProductDisplayWithDescription";

/**
 * Basic SafetyProducts component
 * Usage:
 * <SafetyProducts products={[{id:1, name:"Gloves", description:"Disposable", imageUrl:"/img.png"}]} />
 */
export default function SafetyProducts({ products }) {
  return (
    <>
    <div>
      <ProductDisplayWithDescription
        data={safetyProductsConstant.dataHeadProtection}
        images={safetyProductsConstant.imagesHeadProtection}
        landScapeImg={true}
      />
      </div>
      <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataHearingProtection}
        images={safetyProductsConstant.imagesHearingProtection}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataEyeProtection}
        images={safetyProductsConstant.imagesEyeProtection}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataFaceProtection}
        images={safetyProductsConstant.imagesFaceProtection}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataRespiratoryProtection}
        images={safetyProductsConstant.imagesRespiratoryProtection}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataHandProtection}
        images={safetyProductsConstant.imagesHandProtection}
        landScapeImg={true}
      />
    </div>
     <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataProtectiveClothing}
        images={safetyProductsConstant.imagesProtectiveClothing}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataFeetProtection}
        images={safetyProductsConstant.imagesFeetProtection}
        landScapeImg={true}
      />
    </div>
     <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataFallProtection}
        images={safetyProductsConstant.imagesFallProtection}
        landScapeImg={true}
      />
    </div>
    <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataTrafficSafety}
        images={safetyProductsConstant.imagesTrafficSafety}
        landScapeImg={true}
      />
    </div>
     <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataDetectors}
        images={safetyProductsConstant.imagesDetectors}
        landScapeImg={true}
      />
    </div>
     <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataLOTOEquipments}
        images={safetyProductsConstant.imagesLOTOEquipments}
        landScapeImg={true}
      />
    </div>
      <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataGeneralSafety}
        images={safetyProductsConstant.imagesGeneralSafety}
        landScapeImg={true}
      />
    </div>
      <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataFireExtinguishers}
        images={safetyProductsConstant.imagesFireExtinguishers}
        landScapeImg={true}
      />
    </div>
      <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataSpillKits}
        images={safetyProductsConstant.imagesSpillKits}
        landScapeImg={true}
      />
    </div>
     <div>
       <ProductDisplayWithDescription
        data={safetyProductsConstant.dataFireElectricalArcProtection}
        images={safetyProductsConstant.imagesElectricalArcProtection}
        landScapeImg={true}
      />
    </div>
    </>
  );
}

SafetyProducts.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      imageUrl: PropTypes.string,
    })
  ),
};

SafetyProducts.defaultProps = {
  products: [],
};
